import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type UsersSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_USERS_SORT_OPTION: UsersSortOption = "newest";

const OPTIONS: SortOption<UsersSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function usersSortOptionLabel(option: UsersSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function usersSortOptionToParams(option: UsersSortOption): {
  sortBy: "id" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "id", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "id", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortUsersPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: UsersSortOption;
  setSortOption: (option: UsersSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Users"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
